import React from 'react';
import { ServicesCards } from '../components/sections/ServicesCards';
import { RideCategoriesSection } from '../components/sections/RideCategoriesSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { CTABanner } from '../components/sections/CTABanner';
export function ServicesPage() {
  return <>
      {/* Page Header */}
      <section className="bg-[#0B1F3A] text-white py-20" data-id="element-415">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-416">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-417">Our Services</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-418">
            Comprehensive medical transportation solutions tailored to your
            needs
          </p>
        </div>
      </section>

      <ServicesCards data-id="element-419" />
      <RideCategoriesSection data-id="element-420" />
      <HowItWorksSection data-id="element-421" />
      <CTABanner data-id="element-422" />
    </>;
}